import { useEffect, useRef, useState } from "react";

import { Poppins } from "next/font/google";
import { styled } from "@mui/material/styles";
import { Avatar, Box, Button, Grid, MenuItem, Select } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import {
  CFormContainer,
  CFormHelperText,
  ContainedButton,
  CTextButton,
  CTextField,
  CustomFormContainer,
  CustomFormLabel,
  GetPhoneInputStyles,
} from "./CustomStyles";
import CSelectField from "./CustomFields/CSelectField";
import PhoneInput from "react-phone-input-2";
import GooglePlaceField from "../MainWebsiteComponent/GooglePlaceField/GooglePlaceField";
import { getUserData, isValidEmail } from "../../hooks/HelperFunctions";
import axios from "axios";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import SimpleBackdrop from "../Backdrop/SimpleBackdrop";
import CryptoJS from "crypto-js";

import PhoneField from "phonecomponent/src/PhoneField/PhoneField";
import { useCommon } from "../../app/context";
import { toast } from "react-toastify";

const poppins = Poppins({
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const CONF_S3_DIRECTORY =
  process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
    ? process.env.NEXT_PUBLIC_S3_DIRECTORY_PROD
    : process.env.NEXT_PUBLIC_S3_DIRECTORY_DEV;

const S3_BUCKET = process.env.NEXT_PUBLIC_S3_BUCKET;
const S3_DIRECTORY = CONF_S3_DIRECTORY;
const S3_BASE_URL = process.env.NEXT_PUBLIC_S3_BASE_URL;
const REGION = process.env.NEXT_PUBLIC_S3_REGION;

const NEXT_PUBLIC_CDN_URL = process.env.NEXT_PUBLIC_CDN_URL;

const Profile = (props) => {
  const {
    email,
    phone,
    userData,
    countries,
    timezones,
    signInWith,
    active_modal,
    setAuthSteps,
    setAuthState,
    invite_token,
    invitedMember,
    invitationFrom,
    initializeAgain,
    enrollNowHandler,
    setInvitedMember,
    highestEducations,
    freshNewAccountMember,
  } = props;

  const { enrollNowHandler: enrollNowHandlerFromContext } = useCommon() || {};

  const baseUrl =
    process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
      ? process.env.NEXT_PUBLIC_API_URL_PROD
      : process.env.NEXT_PUBLIC_API_URL_DEV;

  const initialUserObj = {
    first_name: "",
    last_name: "",
    gender: "",
    birthMonth: "",
    birthYear: "",
    email: "",
    phone_number: "",
    addressObj: "",
    addressObj: {},
    manualAddress: false,
    streetAddress: "",
    flOrSuiteNo: "",
    country: "",
    city: "",
    state: "",
    zipCode: "",
    heduId: "",
    currentProfession: "",
    timezone: "",
  };

  let initialUserErrorsObj = {
    first_name: "",
    last_name: "",
    addressObj: "",
    email: "",
    phone_number: "",
    streetAddress: "",
    country: "",
    city: "",
    state: "",
    zipCode: "",
  };

  const [age, setAge] = useState("");
  const [file, setFile] = useState(null);
  const [width, setWidth] = useState(220);
  const [height, setHeight] = useState(220);
  const [getUrl, setGetUrl] = useState(null);
  const [progress, setProgress] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const [userObj, setUserObj] = useState(initialUserObj);
  const [filePathData, setFilePathData] = useState(null);
  const [selectedFile, setSelectedFile] = useState(false);
  const [profilePicLink, setProfilePicLink] = useState(null);
  const [timezoneOptions, setTimezoneOptions] = useState([]);
  const [phoneFieldError, setPhoneFieldError] = useState(true);
  const [countriesOptions, setCountriesOptions] = useState([]);
  const [profilePicLinkTemp, setProfilePicLinkTemp] = useState(null);
  const [isProfilePicUploaded, setIsProfilePicUploaded] = useState(false);
  const [userErrorsObj, setUserErrorsObj] = useState(initialUserErrorsObj);
  const [highestEducationOptions, setHighestEducationOptions] = useState([]);
  let projectEnv = process.env.NEXT_PUBLIC_PROJECT_ENV;

  let mainWebsiteUrl = "";

  //====================create a link to targetPage courses =======================//
  if (projectEnv == "prod") {
    mainWebsiteUrl = "https://mytakbir.com";
  } else {
    mainWebsiteUrl = "https://main-stage.mytakbir.com";
  }

  const handelInputChange = (val, fieldName) => {
    if (fieldName === "last_name" || fieldName === "first_name") {
      const maxLength = 40;
      const value = val;

      const hasOnlyLettersAndSpaces = /^[A-Za-z\s]+$/.test(value);

      if (value.length > maxLength) {
        return;
      } else if (!hasOnlyLettersAndSpaces && value) {
        return;
      }
    }
    setUserObj({ ...userObj, [fieldName]: val });

    if (fieldName in userObj) {
      setUserErrorsObj({ ...userErrorsObj, [fieldName]: "" });
    }
  };

  useEffect(() => {
    let localUserData = getUserData();
    setUserObj({
      ...userObj,
      email: localUserData?.email,
      phone_number: localUserData?.phone_number,
    });

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (invitedMember) {
      setUserObj({
        ...userObj,
        first_name: invitedMember?.first_name,
        last_name: invitedMember?.last_name,
        phone_number: invitedMember?.phone_number?.replace(/^\+/, ""),
      });
    }
  }, [invitedMember]);

  useEffect(() => {
    if (freshNewAccountMember) {
      console.log("freshNewAccountMember", freshNewAccountMember);
      setUserObj({
        ...userObj,
        first_name: freshNewAccountMember?.first_name,
        last_name: freshNewAccountMember?.last_name,
        phone_number: freshNewAccountMember?.phone.replace(/^\+/, ""),
      });
    }
  }, [freshNewAccountMember]);

  useEffect(() => {
    let countryOption = [];
    if (countries?.length > 0) {
      countries?.map((country) => {
        countryOption.push({
          value: country?.name,
          label: country?.name,
        });
      });
      setCountriesOptions(countryOption);
    }
  }, [countries]);

  useEffect(() => {
    let timezoneOption = [];
    if (timezones?.length > 0) {
      timezones?.map((single) => {
        timezoneOption.push({
          value: `${single?.timezone} | GMT ${single?.rawOffset}`,
          label: `${single?.timezone} | GMT ${single?.rawOffset}`,
        });
      });
      setTimezoneOptions(timezoneOption);
    }
  }, [timezones]);

  useEffect(() => {
    let highestEducationOption = [];
    if (highestEducations?.length > 0) {
      highestEducations?.map((single) => {
        highestEducationOption.push({
          value: single?.title,
          label: single?.title,
        });
      });
      setHighestEducationOptions(highestEducationOption);
    }
  }, [highestEducations]);

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const monthOptions = [
    { value: "January", label: "January" },
    { value: "February", label: "February" },
    { value: "March", label: "March" },
    { value: "April", label: "April" },
    { value: "May", label: "May" },
    { value: "June", label: "June" },
    { value: "July", label: "July" },
    { value: "August", label: "August" },
    { value: "September", label: "September" },
    { value: "October", label: "October" },
    { value: "November", label: "November" },
    { value: "December", label: "December" },
  ];

  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ];

  const ageOptions = [
    { value: 1, label: "Male" },
    { value: 2, label: "Female" },
  ];

  const getLastYears = (year) => {
    const years = [];
    const currentYear = new Date().getFullYear();
    let fromYear = currentYear - 5;
    for (let i = 0; i < year; i++) {
      years.push({ value: fromYear - i, label: fromYear - i });
    }
    return years;
  };

  const checkEmailExistence = async () => {
    if (!userObj?.email) return false; // Early return if email is missing

    try {
      // Wait for the recaptcha token
      const token = await new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(
              `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
              { action: "submit" }
            )
            .then(resolve)
            .catch(reject); // Properly catch errors here
        });
      });

      // Prepare data for the API request
      const postData = { email: userObj?.email, token };

      // Make the API request and check the result
      const { data } = await axios.post(
        `${baseUrl}/sendEmailForCheckExistence`,
        postData
      );

      return data?.found || false; // Return true if found, otherwise false
    } catch (error) {
      console.error("Error:", error);
      return false; // In case of error, return false
    }
  };

  const checkPhoneExistence = async () => {
    if (!userObj?.phone_number) return false; // Early return if phone_number is missing

    try {
      // Wait for the recaptcha token
      const token = await new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(
              `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
              { action: "submit" }
            )
            .then(resolve)
            .catch(reject); // Properly catch errors here
        });
      });

      // Prepare data for the API request
      const postData = { phone: userObj?.phone_number, token };

      // Make the API request and check the result
      const { data } = await axios.post(
        `${baseUrl}/sendPhoneForCheckExistence`,
        postData
      );

      return data?.found || false; // Return true if found, otherwise false
    } catch (error) {
      console.error("Error:", error);
      return false; // In case of error, return false
    }
  };

  const validateUserData = async () => {
    let error = 0;
    let newErrorObj = {
      first_name: "",
      last_name: "",
      addressObj: "",
      email: "",
      phone_number: "",
      streetAddress: "",
      country: "",
      city: "",
      state: "",
      zipCode: "",
    };
    if (!userObj?.first_name || userObj?.first_name.trim() === "") {
      error++;
      newErrorObj.first_name = "First name is required";
    } else {
      newErrorObj.first_name = "";
    }

    if (!userObj?.last_name || userObj?.last_name.trim() === "") {
      error++;
      newErrorObj.last_name = "Last name is required";
    } else {
      newErrorObj.last_name = "";
    }

    if (
      !userObj?.manualAddress &&
      userObj?.addressObj &&
      Object.keys(userObj?.addressObj)?.length === 0 &&
      userObj?.addressObj?.constructor === Object
    ) {
      error++;
      newErrorObj.addressObj = "Address is required";
    } else {
      newErrorObj.addressObj = "";
    }

    if (
      userObj?.email &&
      userObj?.email.trim() !== "" &&
      !isValidEmail(userObj?.email.trim())
    ) {
      error++;
      newErrorObj.email = "Email is not valid";
    } else {
      let found =
        userObj?.email != userData?.email ? await checkEmailExistence() : false;
      console.log("found", "i am here", found);
      if (found) {
        error++;
        newErrorObj.email =
          "This email is already associated with an account. Please try a different one.";
      } else {
        newErrorObj.email = "";
      }
    }

    if (
      userObj?.phone_number &&
      userObj?.phone_number.trim() !== "" &&
      userObj?.phone_number.trim().length < 9
    ) {
      error++;
      newErrorObj.phone_number = "Phone is not valid";
      setUserObj({ ...userObj, phone_number: "" });
    } else {
      let found =
        userObj?.phone_number != userData?.phone_number
          ? await checkPhoneExistence()
          : false;
      if (found) {
        error++;
        newErrorObj.phone_number =
          "This phone number is already associated with an account. Please try a different one.";
      } else {
        newErrorObj.phone_number = "";
      }
    }

    if (
      userObj?.manualAddress &&
      (!userObj?.streetAddress || userObj?.streetAddress.trim() === "")
    ) {
      error++;
      newErrorObj.streetAddress = "Street address is required";
    } else {
      newErrorObj.streetAddress = "";
    }

    if (
      userObj?.manualAddress &&
      (!userObj?.country || userObj?.country.trim() === "")
    ) {
      error++;
      newErrorObj.country = "Country is required";
    } else {
      newErrorObj.country = "";
    }

    if (
      userObj?.manualAddress &&
      (!userObj?.city || userObj?.city.trim() === "")
    ) {
      error++;
      newErrorObj.city = "City is required";
    } else {
      newErrorObj.city = "";
    }

    if (
      userObj?.manualAddress &&
      (!userObj?.state || userObj?.state.trim() === "")
    ) {
      error++;
      newErrorObj.state = "State is required";
    } else {
      newErrorObj.state = "";
    }

    if (
      userObj?.manualAddress &&
      (!userObj?.zipCode || userObj?.zipCode.trim() === "")
    ) {
      error++;
      newErrorObj.zipCode = "Zipcode is required";
    } else {
      newErrorObj.zipCode = "";
    }

    setUserErrorsObj({ ...userErrorsObj, ...newErrorObj });

    return error === 0;
  };

  const processData = () => {
    let localUserData = getUserData();
    let newUserObj = {};

    newUserObj.first_name = userObj?.first_name;
    newUserObj.last_name = userObj?.last_name;
    newUserObj.gender = userObj?.gender;
    if (userObj?.birthMonth != "" && userObj?.birthYear != "") {
      newUserObj.birthDate = `${userObj?.birthMonth}-${userObj?.birthYear}`;
    }

    newUserObj.email =
      userObj?.email != "" ? userObj?.email : localUserData?.email;
    newUserObj.phone_number = userObj?.phone_number
      ? userObj?.phone_number
      : localUserData?.phone_number;
    newUserObj.manualAddress = userObj?.manualAddress === true ? 1 : 0;
    newUserObj.address = userObj?.manualAddress
      ? ""
      : userObj?.addressObj?.label;
    newUserObj.addressObj = userObj?.manualAddress ? {} : userObj?.addressObj;
    newUserObj.streetAddress = !userObj?.manualAddress
      ? ""
      : userObj?.streetAddress;
    newUserObj.flOrSuiteNo = !userObj?.manualAddress
      ? ""
      : userObj?.flOrSuiteNo;
    newUserObj.city = !userObj?.manualAddress ? "" : userObj?.city;
    newUserObj.state = !userObj?.manualAddress ? "" : userObj?.state;
    newUserObj.zipCode = !userObj?.manualAddress ? "" : userObj?.zipCode;
    newUserObj.currentProfession = userObj?.currentProfession;
    newUserObj.timezone = userObj?.timezone.split("|")[0].trim();
    if (profilePicLink != "") {
      newUserObj.image = profilePicLink;
    }

    newUserObj.heduId = highestEducations?.find(
      (single) => single?.title == userObj?.heduId
    )?.heduId;
    newUserObj.heduTitle = highestEducations?.find(
      (single) => single?.title == userObj?.heduId
    )?.title;
    newUserObj.countryId = countries?.find(
      (single) => single?.name == userObj?.country
    )?.countryId;

    return newUserObj;
  };
  const handleClickSave = async () => {
    setShowLoader(true);
    let isValid = await validateUserData();

    if (!isValid) {
      setShowLoader(false);
      return false;
    }
    let postData = processData();

    try {
      axios
        .post(`${baseUrl}/addPrimaryInfo`, postData)
        .then((response) => {
          if (!response?.data?.error) {
            const newUserData = {
              id: response?.data?.body?.id,
              firstName: response?.data?.body?.firstName,
              lastName: response?.data?.body?.lastName,
              email: response?.data?.body?.email,
              phone_number: response?.data?.body?.phone_number,
              image: response?.data?.body?.image,
              userRole: response?.data?.body?.userRole,
            };
            localStorage.setItem("userData", JSON.stringify(newUserData));
            localStorage.setItem(
              "profile_completed",
              response?.data?.profile_completed
            );
            setInvitedMember(null);
            localStorage.removeItem("invitedMember");
            setAuthSteps(0);
            setAuthState(false);
            setShowLoader(false);
            if (freshNewAccountMember) {
              var signinToken = CryptoJS.AES.encrypt(
                JSON.stringify({
                  email: freshNewAccountMember.email,
                  userToken: localStorage.getItem("userToken"),
                }),
                "token-based-signin-aglbnd-854256-secret-key"
              ).toString();

              let accountType =
                freshNewAccountMember?.org_full_name != ""
                  ? "organization"
                  : "individual";
              localStorage.removeItem("newTeachingAccount");
              window.location.replace(
                (mainWebsiteUrl += `?signinToken=${signinToken}&targetPage=create-new-teaching-account?account_type=${accountType}`)
              );
            } else {
              let pendingOperation = localStorage.getItem("pendingOperation")
                ? localStorage.getItem("pendingOperation")
                : null;

              if (pendingOperation && pendingOperation == "enrollment") {
                const pendingOperationData = JSON.parse(
                  localStorage.getItem("pendingOperationData")
                );
                const userAuthenticated =
                  localStorage.getItem("userAuthenticated");

                if (typeof enrollNowHandler == "function") {
                  enrollNowHandler(pendingOperationData, userAuthenticated);
                } else {
                  enrollNowHandlerFromContext(
                    pendingOperationData,
                    userAuthenticated
                  );
                }

                localStorage.removeItem("pendingOperation");
                localStorage.removeItem("pendingOperationData");
              }
              initializeAgain();
            }
          }
        })
        .catch((err) => {
          setShowLoader(false);
          console.log(err);
          if (err?.response?.data?.message) {
          }
        });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const capitalizeWords = (str) => {
    return str
      .split(" ")
      .map((word) => {
        // Capitalize the first letter and convert the rest to lowercase
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(" ");
  };

  useEffect(() => {
    console.log("userErrorsObj", userErrorsObj);
  }, [userErrorsObj]);

  useEffect(() => {
    if (file && getUrl && filePathData) {
      uploadFile();
      // setUploaded(true);
    }
  }, [getUrl, file, filePathData]);

  const xhrRef = useRef(null);
  const abortUpload = () => {
    if (xhrRef.current) {
      xhrRef.current.abort();
      console.log("Upload aborted");
    }
  };

  const uploadFileWithProgress = (url, file) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhrRef.current = xhr;

      xhr.open("PUT", url, true);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const progress = Math.round((event.loaded * 100) / event.total);
          console.log(progress, 404, event);
          setProgress(progress);
        }
      };

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve({
            message: "Upload successful",
            status: xhr.status,
            error: false,
          });
        } else {
          reject(new Error(`Upload failed with status: ${xhr.status}`));
        }
      };

      xhr.onerror = () => reject(new Error("Upload failed"));

      xhr.setRequestHeader("Content-Type", file.type);
      xhr.send(file);
    });
  };

  const uploadFile = async () => {
    // if (!selectedFile) return;

    const presignedUrl = getUrl;
    const formattedUrl = presignedUrl?.replace("\\", "");

    try {
      let result = await uploadFileWithProgress(formattedUrl, file);

      if (!result?.error) {
        setGetUrl(null);
        setProgress(0);
        setProfilePicLink(profilePicLinkTemp);
        setIsProfilePicUploaded(true);
        setSelectedFile(false);
        setShowLoader(false);
      }
    } catch (error) {
      console.error("Error uploading file", error);
    }
  };
  useEffect(() => {
    if (profilePicLink != "") setProfilePicLinkTemp(null);
  }, [profilePicLink]);

  useEffect(() => {
    if (!file) {
      return;
    }

    try {
      !selectedFile && uploadFileToS3(file);
      !selectedFile && setSelectedFile(true);
    } catch (error) {
      console.error(error);
    }
  }, [file]);

  const uploadFileHandler = async (e) => {
    const imageFormats = ["image/jpeg", "image/jpg", "image/png"];
    const selectedFile = e.target.files[0];
    if (selectedFile && ![...imageFormats].includes(selectedFile?.type)) {
      toast.dismiss();
      toast.error("Unsupported format. Use .jpg, .jpeg, .png for images");

      return;
    }
    setShowLoader(true);
    setFile(e.target.files[0]);
    setTimeout(() => {
      setShowLoader(false);
    }, 10000);
  };
  const fetchPresignedUrl = async (file) => {
    let objFilePath = S3_DIRECTORY;

    objFilePath += "909/profile/" + file?.name;

    let dataToSend = {
      file_type: file?.type.startsWith("video/")
        ? "videos"
        : file?.type.startsWith("image/")
        ? "images"
        : "documents",
      file_visibility: "Public",
      key: file?.name?.replace(/\s+/g, "-"),
    };

    const userToken = localStorage.getItem("userToken");

    let response = await axios.post(
      `${baseUrl}/getFileUploadPresignedUrl`,
      dataToSend,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }
    );

    if (response?.status === 200) {
      setGetUrl(response?.data?.url);
      setProfilePicLinkTemp(response?.data?.key);
      setFilePathData(response?.data?.key?.replace("\\", ""));
    }
  };

  const uploadFileToS3 = async (file) => {
    if (isProfilePicUploaded) {
      await removeProfilePictureFromServer();
    }
    const presignedUrl = await fetchPresignedUrl(file);
  };

  const removeProfilePictureFromServer = async () => {
    abortUpload();
    if (filePathData) {
      let data = {
        key: filePathData,
      };
      try {
        const response = await axios.delete(`${baseUrl}/deleteMediaFromS3`, {
          data: data,
        });
        if (response?.status === 200) {
          setFilePathData(null);
          setIsProfilePicUploaded(false);
        }
      } catch (error) {
        console.error("Error uploading file", error);
      }
    }
  };

  const deleteProfilePictureHandler = async () => {
    setShowLoader(true);
    await removeProfilePictureFromServer();
    setSelectedFile(false);
    setProgress(0);
    setProfilePicLink(null);
    setFile(null);
    setGetUrl(null);
    setShowLoader(false);
  };
  //* ================================================== phone component =========================================================== *//

  const onChangePhone = (contryCode, phoneFormatted) => {
    let val = `${contryCode} ${phoneFormatted}`?.replace(/\D/g, "");
    setUserObj({
      ...userObj,
      phone_number: val,
    });
  };
  const clearPhoneError = () => {
    setUserErrorsObj({
      ...userErrorsObj,
      phone_number: "",
    });
  };
  const handleCountryChangeReset = () => {
    setUserObj({
      ...userObj,
      phone_number: "",
    });
  };

  //* ================================================== phone component =========================================================== *//

  const handlePhoneInputChange = (val, info, e) => {
    let phoneNumber = val;
    let dialCode = info?.dialCode;
    if (phoneNumber == dialCode) {
      handelInputChange(null, "phone_number");
    } else {
      handelInputChange(val, "phone_number");
    }
  };

  const currentProfessionChangeHandler = (e) => {
    if (e.target.value.length < 51) {
      handelInputChange(e.target.value, "currentProfession");
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CustomFormLabel sx={{ fontWeight: 500, color: "#001233" }}>
          Full Name<span className="asterisk">*</span>
        </CustomFormLabel>

        <CFormContainer component="form">
          <div className="FormGroupFull">
            <CTextField
              placeholder="First name"
              onChange={(e) =>
                handelInputChange(capitalizeWords(e.target.value), "first_name")
              }
              error={userErrorsObj?.first_name != ""}
              value={userObj?.first_name}
            />
            <CTextField
              placeholder="Last name"
              onChange={(e) =>
                handelInputChange(capitalizeWords(e.target.value), "last_name")
              }
              error={userErrorsObj?.last_name != ""}
              value={userObj?.last_name}
            />
          </div>
          {userErrorsObj?.first_name != "" || userErrorsObj?.last_name != "" ? (
            <CFormHelperText sx={{ color: "#BA1A1A" }}>
              Enter your full name
            </CFormHelperText>
          ) : (
            <CFormHelperText sx={{ color: "#33415C" }}>
              Enter your full official name
            </CFormHelperText>
          )}
        </CFormContainer>
      </Grid>
      <Grid item xs={12}>
        <CustomFormLabel>Profile photo</CustomFormLabel>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <Avatar
            sx={{ width: 72, height: 72, background: "#E8EAED" }}
            src={profilePicLink}
          >
            <RiUserLine />
          </Avatar>

          <Button
            component="label"
            role={undefined}
            variant="outlined"
            tabIndex={-1}
            startIcon={<FileUploadOutlinedIcon />}
            sx={{
              padding: "11px 18px !important",
              color: "#004FE0 !important",
              textTransform: "initial !important",
              fontFamily: poppins.style.fontFamily,
              border: "1px solid #E4E8EC !important",
              borderRadius: "8px !important",
              "&:hover": { borderColor: "#E4E8EC" },
            }}
          >
            Upload file
            <VisuallyHiddenInput
              type="file"
              accept="image/*"
              onChange={(event) => uploadFileHandler(event)}
            />
          </Button>
          {isProfilePicUploaded && (
            <Button
              variant="outlined"
              sx={{
                width: "48px",
                height: "48px",
                padding: "11px 0px !important",
                color: "#BA1A1A !important",
                textTransform: "initial !important",
                fontFamily: poppins.style.fontFamily,
                border: "1px solid #E4E8EC !important",
                borderRadius: "8px !important",
                "&:hover": { borderColor: "#E4E8EC" },
              }}
              onClick={(e) => deleteProfilePictureHandler()}
            >
              <DeleteForeverOutlinedIcon />
            </Button>
          )}
        </Box>
      </Grid>
      <Grid item xs={12}>
        <CustomFormLabel>Gender</CustomFormLabel>
        <CSelectField
          options={genderOptions}
          value={userObj?.gender}
          onChange={(e) => handelInputChange(e.target.value, "gender")}
          placeholder="Select"
          customStyles={{
            select: {
              // fontSize: "20px",
              fontWeight: 400,
              borderRadius: "8px",
            },
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <CustomFormLabel>Date of birth</CustomFormLabel>
        <Box component="form">
          <div className="FormGroup">
            <CSelectField
              options={monthOptions}
              value={userObj?.birthMonth}
              onChange={(e) => handelInputChange(e.target.value, "birthMonth")}
              placeholder="Month"
              customStyles={{
                select: {
                  border: "0px",
                  borderTopLeftRadius: "8px",
                  borderTopRightRadius: "0px",
                  borderBottomLeftRadius: "8px",
                  borderBottomRightRadius: "0px",
                },
              }}
            />
            <CSelectField
              options={getLastYears(80)}
              value={userObj?.birthYear}
              onChange={(e) => handelInputChange(e.target.value, "birthYear")}
              placeholder="Year"
              customStyles={{
                select: {
                  border: "0px",
                  borderTopRightRadius: "8px",
                  borderTopLeftRadius: "0px",
                  borderBottomRightRadius: "8px",
                  borderBottomLeftRadius: "0px",
                },
              }}
            />
          </div>
        </Box>
      </Grid>
      {(userData?.email == "" || userData?.email == null) && (
        <Grid item xs={12}>
          <CustomFormLabel>Email address</CustomFormLabel>
          <CTextField
            placeholder="Email address"
            value={userObj?.email}
            onChange={(e) =>
              handelInputChange(e.target.value.toLowerCase(), "email")
            }
            error={userErrorsObj?.email != ""}
          />
          {userErrorsObj?.email != "" && (
            <CFormHelperText sx={{ color: "#BA1A1A" }}>
              {userErrorsObj?.email}
            </CFormHelperText>
          )}
        </Grid>
      )}

      {(userData?.phone_number == "" || userData?.phone_number == null) && (
        <Grid item xs={12}>
          <CustomFormLabel>Phone number </CustomFormLabel>
          <div
            className={`PhoneFieldManContainer ${
              userErrorsObj?.phone_number != "" ? "error" : ""
            }`}
          >
            <PhoneField
              helperText=""
              Search={false}
              error={userErrorsObj?.phone_number != ""}
              phone={userObj?.phone_number}
              onChangePhone={onChangePhone}
              clearPhoneError={clearPhoneError}
              handleCountryChangeReset={handleCountryChangeReset}
              BrOPen="("
              BrClose=")"
            />

            {userErrorsObj?.phone_number != "" && (
              <CFormHelperText sx={{ color: "#BA1A1A" }}>
                {userErrorsObj?.phone_number}
              </CFormHelperText>
            )}
          </div>
        </Grid>
      )}
      <Grid item xs={12}>
        <div style={{ marginTop: "-8px" }}>
          <CustomFormLabel>
            Address<span className="asterisk">*</span>
          </CustomFormLabel>
          {!userObj?.manualAddress && (
            // <CTextField placeholder="Your current resident address" />
            <GooglePlaceField
              // label="Address"
              // validation={true}
              // handleChange={handleAddressChange}
              // required
              HideRequireText={false}
              placeholder="Current address"
              // value={checkJsonStringOrNot(data?.addressObj)}
              handleChange={(address) =>
                handelInputChange(address, "addressObj")
              }
              error={userErrorsObj?.addressObj ? true : false}
              // error={error.addressObj ? true : false}
            />
          )}
        </div>
        {userObj?.manualAddress && (
          <CustomFormContainer component="form">
            <CSelectField
              options={countriesOptions}
              value={userObj?.country}
              onChange={(e) => handelInputChange(e.target.value, "country")}
              placeholder="Country"
              customStyles={{
                select: {
                  border: "8px",
                },
              }}
              error={userErrorsObj?.country != "" ? true : false}
            />
            <CTextField
              placeholder="Street address"
              value={userObj?.streetAddress}
              onChange={(e) =>
                handelInputChange(e.target.value, "streetAddress")
              }
              error={userErrorsObj?.streetAddress != "" ? true : false}
            />
            <CTextField
              placeholder="Apt, floor, bldg"
              value={userObj?.flOrSuiteNo}
              onChange={(e) => handelInputChange(e.target.value, "flOrSuiteNo")}
            />
            <CTextField
              placeholder="City / town / village"
              value={userObj?.city}
              onChange={(e) => handelInputChange(e.target.value, "city")}
              error={userErrorsObj?.city != "" ? true : false}
            />
            <CTextField
              placeholder="Province / state / territory"
              value={userObj?.state}
              onChange={(e) => handelInputChange(e.target.value, "state")}
              error={userErrorsObj?.state != "" ? true : false}
            />
            <CTextField
              placeholder="Postal code"
              value={userObj?.zipCode}
              onChange={(e) => handelInputChange(e.target.value, "zipCode")}
              error={userErrorsObj?.zipCode != "" ? true : false}
            />
          </CustomFormContainer>
        )}
        {(userErrorsObj?.addressObj != "" ||
          userErrorsObj?.streetAddress != "" ||
          userErrorsObj?.country != "" ||
          userErrorsObj?.city != "" ||
          userErrorsObj?.state != "" ||
          userErrorsObj?.zipCode != "") && (
          <CFormHelperText sx={{ color: "#BA1A1A" }}>
            Address is required
          </CFormHelperText>
        )}

        {!userObj?.manualAddress && (
          <CTextButton
            variant="text"
            sx={{ p: 0, fontSize: "14px", fontWeight: 400 }}
            onClick={(e) => handelInputChange(true, "manualAddress")}
            //   onClick={handleForgotPassFn ? handleForgotPassFn : undefined}
          >
            Enter address manually
          </CTextButton>
        )}
        {userObj?.manualAddress && (
          <CTextButton
            variant="text"
            sx={{ p: 0, fontSize: "14px", fontWeight: 400 }}
            onClick={(e) => handelInputChange(false, "manualAddress")}
            //   onClick={handleForgotPassFn ? handleForgotPassFn : undefined}
          >
            Search your address
          </CTextButton>
        )}
      </Grid>

      <Grid item xs={12}>
        <CustomFormLabel>Highest education</CustomFormLabel>
        <CSelectField
          options={highestEducationOptions}
          value={userObj?.heduId}
          onChange={(e) => handelInputChange(e.target.value, "heduId")}
          placeholder="Select"
          customStyles={{
            select: {
              border: "8px",
            },
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomFormLabel>Current profession</CustomFormLabel>
        <CTextField
          placeholder="Current profession"
          value={userObj?.currentProfession}
          onChange={(e) => currentProfessionChangeHandler(e)}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomFormLabel>Timezone</CustomFormLabel>
        <CSelectField
          options={timezoneOptions}
          value={userObj?.timezone}
          onChange={(e) => handelInputChange(e.target.value, "timezone")}
          placeholder="Select"
          customStyles={{
            select: {
              border: "8px",
            },
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <ContainedButton
          variant="contained"
          fullWidth
          endIcon={<ArrowForwardRoundedIcon />}
          onClick={(e) => handleClickSave()}
          //   onClick={handleSubmitFn ? handleSubmitFn : undefined}
        >
          Save
        </ContainedButton>
      </Grid>
      <SimpleBackdrop open={showLoader} />
    </Grid>
  );
};

export default Profile;

export function RiUserLine(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="#7d8597"
        d="M4 22a8 8 0 1 1 16 0h-2a6 6 0 0 0-12 0zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4"
      ></path>
    </svg>
  );
}
